/** @format */

import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import { getDashboardStats } from "../../services/Api/DashboardApi";

const Dashboard = () => {
	const [stats, setStats] = useState(null);
	const [loading, setLoading] = useState(false);

	const fetchDashboardStats = async () => {
		try {
			setLoading(true);
			const res = await getDashboardStats();
			setStats(res.data.data);
		} catch (error) {
			console.error("Failed to load dashboard stats", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchDashboardStats();
	}, []);

	// Card configurations with icons and colors
	const cardConfigs = [
		// {
		// 	title: "Total Users",
		// 	value: stats?.userCount || 0,
		// 	icon: "👥",
		// 	gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
		// 	lightBg: "#f0f4ff",
		// },
		{
			title: "Total Revenue",
			value: `$${stats?.totalRevenue?.toLocaleString() || 0}`,
			icon: "💰",
			gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
			lightBg: "#fff0f6",
		},
		{
			title: "Donation Revenue",
			value: `$${stats?.donationRevenue?.toLocaleString() || 0}`,
			icon: "🎁",
			gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
			lightBg: "#f0fbff",
		},
		{
			title: "Package Revenue",
			value: `$${stats?.packageRevenue?.toLocaleString() || 0}`,
			icon: "📦",
			gradient: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
			lightBg: "#f0fff8",
		},
		// {
		// 	title: "Active Package Users",
		// 	value: stats?.activePackageUsers || 0,
		// 	icon: "✨",
		// 	gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
		// 	lightBg: "#fff8f0",
		// },
		{
			title: "Pending Queries",
			value: stats?.queryCount || 0,
			icon: "📬",
			gradient: "linear-gradient(135deg, #30cfd0 0%, #330867 100%)",
			lightBg: "#f0f8ff",
		},
	];

	return (
		<div className="dashboard-container">
			{/* Header Section */}
			<div className="dashboard-header">
				<div className="header-content">
					<div className="header-text">
						<h1 className="dashboard-title">
							Welcome Back, Admin! 👋
						</h1>
						<p className="dashboard-subtitle">
							Here's a snapshot of your latest statistics and insights.
						</p>
					</div>
					<div className="header-date">
						<span className="date-badge">
							{new Date().toLocaleDateString("en-US", {
								weekday: "long",
								year: "numeric",
								month: "long",
								day: "numeric",
							})}
						</span>
					</div>
				</div>
			</div>

			{/* Stats Grid */}
			{loading ? (
				<div className="loading-container">
					<div className="loader"></div>
					<p className="loading-text">Loading your dashboard...</p>
				</div>
			) : (
				<div className="dashboard-grid">
					{cardConfigs.map((config, index) => (
						<DashboardCard
							key={index}
							{...config}
							delay={index * 0.1}
						/>
					))}
				</div>
			)}
		</div>
	);
};

const DashboardCard = ({ title, value, icon, gradient, lightBg, delay }) => {
	return (
		<div
			className="dashboard-card"
			style={{
				animationDelay: `${delay}s`,
			}}
		>
			<div className="card-header">
				<div
					className="card-icon"
					style={{
						background: lightBg,
					}}
				>
					<span className="icon-emoji">{icon}</span>
				</div>
			</div>
			<div className="card-body">
				<p className="card-title">{title}</p>
				<h2 className="card-value">{value}</h2>
			</div>
			<div
				className="card-accent"
				style={{
					background: gradient,
				}}
			></div>
		</div>
	);
};

export default Dashboard;